import React, { memo, forwardRef } from "react";
const SvgSetbuilder = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M2.783 16.879C2.261 16.717 2 16.42 2 15.988s.261-.729.783-.891c.54-.18.927-.513 1.161-.999.252-.486.378-1.215.378-2.187V7.375c0-1.188.27-2.043.81-2.565.54-.54 1.377-.81 2.511-.81h.675c.54 0 .81.243.81.729s-.27.729-.81.729h-.54c-.63 0-1.071.189-1.323.567-.234.36-.351.918-.351 1.674v4.617c0 2.034-.801 3.249-2.403 3.645v.054c1.602.396 2.403 1.611 2.403 3.645v4.617c0 .756.117 1.314.351 1.674.252.378.693.567 1.323.567h.54c.54 0 .81.243.81.729s-.27.729-.81.729h-.675c-1.134 0-1.971-.27-2.511-.81-.54-.522-.81-1.377-.81-2.565v-4.536c0-.972-.126-1.701-.378-2.187-.234-.486-.621-.819-1.161-.999zM30.345 15.097c.522.162.783.459.783.891s-.261.729-.783.891c-.54.18-.936.513-1.188.999-.234.486-.351 1.215-.351 2.187v4.536c0 1.188-.27 2.043-.81 2.565-.54.54-1.377.81-2.511.81h-.675c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h.54c.63 0 1.062-.189 1.296-.567.252-.36.378-.918.378-1.674V19.66c0-2.034.801-3.249 2.403-3.645v-.054c-1.602-.396-2.403-1.611-2.403-3.645V7.699c0-.756-.126-1.314-.378-1.674-.234-.378-.666-.567-1.296-.567h-.54c-.54 0-.81-.243-.81-.729S24.27 4 24.81 4h.675c1.134 0 1.971.27 2.511.81.54.522.81 1.377.81 2.565v4.536c0 .972.117 1.701.351 2.187.252.486.648.819 1.188.999z"
      />
      <rect width={6} height={14} x={8} y={9} fill="#DBDBDB" rx={1} />
      <rect width={6} height={14} x={19} y={9} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M16.404 8.528a.7.7 0 01.7.7v12.6a.7.7 0 11-1.4 0v-12.6a.7.7 0 01.7-.7z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgSetbuilder.displayName = "SvgSetbuilder";
const MemoForwardRef = memo(SvgSetbuilder);
export default MemoForwardRef;
